import {
	FieldErrors,
	FieldValues,
	UseFormRegister,
	UseFormSetValue,
	UseFormTrigger,
} from 'react-hook-form';

import {
	GridContainer,
	Input,
	SpinnerOverlay,
	SubmissionButtons,
} from '@components/common';

import { regExpLetters, regExpMacMac, regExpNumbers } from '@constants/regExp';
import {
	ERUConfigurationFormFields,
	ERUConfigurationFormTabNames,
	RU_CONFIGURATION_FORM_AREAS,
	RU_FIELDS_TO_TEST,
	VLAN_ID_TOOLTIP,
} from '../constants';

import styles from '../RUConfigurationFormTabs.module.scss';

interface IRUConfigurationFormProps {
	errors: FieldErrors<FieldErrors>;
	isLoading: boolean;
	isEditMode: boolean;
	isSubmitDisabled: boolean;
	onClose: () => void;
	setCurrentTab: (tab: string) => void;
	register: UseFormRegister<FieldValues>;
	setValue: UseFormSetValue<FieldValues>;
	trigger: UseFormTrigger<FieldValues>;
}

const RUConfigurationForm = ({
	errors,
	isLoading,
	isSubmitDisabled,
	isEditMode,
	onClose,
	setCurrentTab,
	register,
	setValue,
	trigger,
}: IRUConfigurationFormProps) => {
	const confirmHandler = async () => {
		const isValid = await trigger(RU_FIELDS_TO_TEST);

		if (!isValid) {
			return;
		}

		setCurrentTab(ERUConfigurationFormTabNames.carriersData);
	};

	const negativeHandler = () => onClose();

	const positiveHandler = () => confirmHandler();

	return (
		<GridContainer
			columns={2}
			customClassName={styles.ruConfigurationFormContainer}
			gap='15px 20px'
			gridTemplateAreas={RU_CONFIGURATION_FORM_AREAS}
		>
			{isLoading && <SpinnerOverlay/>}
			<Input
				containerClassName={styles.name}
				disabled
				errorMessage={errors?.name?.message}
				label='Name'
				name={ERUConfigurationFormFields.name}
				placeholder='Enter configuration name'
				regexValidation={regExpLetters}
				register={register}
				required
				setValue={setValue}
			/>
			<Input
				containerClassName={styles.vlanId}
				errorMessage={errors?.vlanId?.message}
				infoTooltip={VLAN_ID_TOOLTIP}
				label='CU VLAN-ID'
				name={ERUConfigurationFormFields.vlanId}
				placeholder='Enter CU VLAN-ID'
				regexValidation={regExpNumbers}
				register={register}
				required
				setValue={setValue}
			/>
			<Input
				containerClassName={styles.ruMacAddress}
				errorMessage={errors?.ruMacAddress?.message}
				label='O_RU Mac Address'
				name={ERUConfigurationFormFields.ruMacAddress}
				placeholder='Enter O_RU Mac Address'
				regexValidation={regExpMacMac}
				register={register}
				required
				setValue={setValue}
			/>
			<Input
				containerClassName={styles.duMacAddress}
				errorMessage={errors?.duMacAddress?.message}
				label='O_DU Mac Address'
				name={ERUConfigurationFormFields.duMacAddress}
				placeholder='Enter O_DU Mac Address'
				regexValidation={regExpMacMac}
				register={register}
				required
				setValue={setValue}
			/>
			<SubmissionButtons
				className={styles.submitButtons}
				disabledPositive={isSubmitDisabled}
				negativeHandler={negativeHandler}
				negativeLabel='Cancel'
				positiveHandler={positiveHandler}
				positiveLabel={isEditMode ? 'Save and update' : 'Next'}
			/>
		</GridContainer>
	);
};

export default RUConfigurationForm;
